export const exportCsv = (headers, body, documentName) => {
  const csvString = getCSVString(headers, body)
  const csvBlob = getCSVBlob(csvString)
  serveCSVBlob(csvBlob, documentName)
}

const getCSVString = (headers, body) => {
  const csvData = [headers, ...body]
  return csvData.join('\n')
}

const getCSVBlob = (csvString) => {
  return new Blob([csvString], { type: 'text/csv' })
}

const serveCSVBlob = (csvBlob, documentName) => {
  const url = URL.createObjectURL(csvBlob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${documentName}.csv`)
  link.setAttribute('target', '_blank')
  document.body.appendChild(link)
  link.click()
  const parentNode = link.parentNode
  if (parentNode) {
    parentNode.removeChild(link)
  }
}

export const buildTableHeaders = (t, headers) => {
  return headers.map(({ label, args, ...restAttrs }) => ({
    label: t(label, args),
    ...restAttrs
  }))
}

export const validateCSVHeaders = (file, expectedColumns) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(expectedColumns)) {
      reject('csvValidator.invalidSchema')
      return
    }
    const reader = new FileReader()
    reader.onload = (event) => {
      try {
        const content = event.target.result
        const lines = content.split('\n')
        if (lines.length === 0) {
          reject('csvValidator.emptyFile')
          return
        }
        const headers = lines[0].split(',').map((h) => h.trim())
        if (headers.length !== expectedColumns.length) {
          reject('csvValidator.columnCountMismatch')
          return
        }
        const rows =
          lines.length > 1 ? lines[1]?.split(',').map((h) => h.trim()) : []
        if (rows.length === 0) {
          reject('csvValidator.dataEmpty')
          return
        }
        const errors = []
        expectedColumns.forEach((expected, index) => {
          if (headers[index] !== expected) {
            errors.push({
              position: index + 1,
              expected,
              found: headers[index]
            })
          }
        })
        if (errors.length > 0) {
          // reject({
          //   message: 'csvValidator.headerMismatch',
          //   errors
          // })
          reject('csvValidator.headerMismatch')
        } else {
          resolve({ valid: true, headers })
        }
      } catch (e) {
        console.error(e)
        reject('csvValidator.parseError')
      }
    }
    reader.onerror = (e) => {
      console.error(e)
      reject('csvValidator.readError')
    }
    reader.readAsText(file)
  })
}
